export default {
  namespace: 'cps',
  state: {},
  mutations: {},
  actions: {},
  modules: {},
};
